import { render, staticRenderFns } from "./wy-configuration-trending-topics-tab.vue?vue&type=template&id=c6b8b6d0&"
import script from "./wy-configuration-trending-topics-tab.vue?vue&type=script&lang=js&"
export * from "./wy-configuration-trending-topics-tab.vue?vue&type=script&lang=js&"
import style0 from "./wy-configuration-trending-topics-tab.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports